/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
export type paths = {
    readonly '/api/containers': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all service containers */
        readonly get: operations['getContainers']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/containers/+/inspect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Inspect service container */
        readonly get: operations['inspectContainer']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/containers/+/logs': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get service container logs */
        readonly get: operations['getContainerLogsStream']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/containers/+/operation': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Perform an operation on a service container */
        readonly put: operations['executeServiceContainerOperation']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/containers/+/state': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get container state */
        readonly get: operations['getContainerState']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/containers/orchestrator': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Returns info about orchestrator being used to run Connectware */
        readonly get: operations['orchestrator']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all core containers */
        readonly get: operations['getCoreContainers']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers/+/inspect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Inspect core container */
        readonly get: operations['inspectCoreContainer']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers/+/logs': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get core container logs */
        readonly get: operations['getCoreContainerLogsStream']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers/+/operation': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Perform an operation on a core container */
        readonly put: operations['executeCoreContainerOperation']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers/+/state': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get core container state */
        readonly get: operations['getCoreContainerState']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/core-containers/orchestrator': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Returns info about orchestrator being used to run Connectware */
        readonly get: operations['coreOrchestrator']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/healthz': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Meta endpoint that returns 200 if server is ready */
        readonly get: operations['healthz']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/images': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all images */
        readonly get: operations['getImages']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/images/+/inspect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Inspect a image */
        readonly get: operations['inspectImages']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/networks': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all networks */
        readonly get: operations['getNetworks']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/networks/+/inspect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Inspect a network */
        readonly get: operations['inspectNetworks']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/volumes': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all volumes */
        readonly get: operations['getVolumes']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/volumes/+/inspect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Inspect a volume */
        readonly get: operations['inspectVolumes']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly ContainerResponse: components['schemas']['DockerContainerResponse'] | components['schemas']['KubernetesContainerResponse']
        readonly ContainersResponse: components['schemas']['DockerContainersResponse'] | components['schemas']['KubernetesContainersResponse']
        readonly DockerContainerMount: {
            readonly Destination: string
            readonly Mode: string
            readonly Name?: string
            readonly Propagation: string
            readonly RW: boolean
            readonly Source: string
        }
        readonly DockerContainerResponse: {
            readonly Config: {
                readonly Env: readonly string[]
                readonly ExposedPorts: {
                    readonly [key: string]: Record<string, never>
                }
                readonly Image: string
                readonly Labels: {
                    readonly [key: string]: string
                }
                readonly WorkingDir: string
            }
            readonly Created: string
            readonly HostConfig: {
                readonly CapAdd?:
                    | {
                          readonly [key: string]: unknown
                      }
                    | readonly unknown[]
                    | readonly string[]
                    | string
                readonly Privileged?: boolean
            }
            readonly Id: string
            readonly Mounts: readonly components['schemas']['DockerContainerMount'][]
            readonly Name: string
            readonly State: {
                readonly Dead: boolean
                readonly FinishedAt: string
                readonly Paused: boolean
                readonly Restarting: boolean
                readonly Running: boolean
                readonly StartedAt: string
                readonly Status: string
            }
        }
        readonly DockerContainersResponse: readonly {
            readonly Mounts: readonly ({
                readonly Driver?: string
                readonly Type: string
            } & components['schemas']['DockerContainerMount'])[]
            readonly Names: readonly string[]
            readonly State: string
        }[]
        readonly DockerVolumeResponse: {
            readonly CreatedAt: string
            readonly Labels: {
                readonly [key: string]: string
            }
            readonly Name: string
        }
        readonly DockerVolumesResponse: {
            readonly Volumes: readonly components['schemas']['DockerVolumeResponse'][]
            readonly Warnings: string
        }
        readonly KubernetesContainerMount: {
            /** @enum {string} */
            readonly Destination: '?'
            /** @enum {string} */
            readonly Driver?: 'persistentVolumeClaim' | 'secret'
            /** @enum {string} */
            readonly Mode: '?'
            readonly Name: string
            /** @enum {string} */
            readonly Propagation: '?'
            /** @enum {string} */
            readonly RW: '?'
            /** @enum {string} */
            readonly Source: '?'
            /** @enum {string} */
            readonly Type: 'volume'
        }
        readonly KubernetesContainerResponse: {
            readonly Config: {
                readonly Env: readonly string[]
                readonly ExposedPorts: Record<string, never>
                readonly Image: string
                readonly Labels: Record<string, never>
                readonly WorkingDir: string
            }
            readonly Created: string | null
            readonly HostConfig: {
                readonly CapAdd: null
                /** @enum {boolean} */
                readonly Privileged: false
            }
            readonly Id: string | null
            readonly Mounts: readonly components['schemas']['KubernetesContainerMount'][]
            readonly Name: string
            readonly State: {
                readonly Status: string | null
            }
        }
        readonly KubernetesContainersResponse: readonly {
            /** @enum {string} */
            readonly Command: '?'
            readonly Id?: string
            /** @enum {string} */
            readonly Image: '?'
            /** @enum {string} */
            readonly ImageID: '?'
            readonly Mounts: readonly components['schemas']['KubernetesContainerMount'][]
            readonly Names: [] | [string | null]
            readonly State?: string
        }[]
        readonly KubernetesVolumesResponse: {
            readonly Volumes: []
            readonly Warnings: null
        }
        /** @enum {string} */
        readonly Orchestrator: 'Docker' | 'Kubernetes'
        readonly OrchestratorResponse: {
            readonly orchestrator: components['schemas']['Orchestrator']
        }
        readonly VolumeResponse: components['schemas']['DockerVolumeResponse']
        readonly VolumesResponse: components['schemas']['DockerVolumesResponse'] | components['schemas']['KubernetesVolumesResponse']
    }
    responses: never
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

interface operations {
    readonly getContainers: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description All service containers */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ContainersResponse']
                }
            }
            /** @description Failed to get all service containers */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly inspectContainer: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the service container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Service container inspect */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ContainerResponse']
                }
            }
            /** @description Failed to inspect service container */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getContainerLogsStream: {
        readonly parameters: {
            readonly query?: {
                /** @description Timestamp for the start */
                readonly since?: string
                /** @description Use 'all' to retrieve all, or a number for a limited set */
                readonly tail?: string
                /** @description If the logs should yield timestamp */
                readonly timestamps?: 'true' | 'false'
                /** @description Timestamp for the end */
                readonly until?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the service container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Service container logs */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': string
                }
            }
            /** @description Failed to get container logs */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly executeServiceContainerOperation: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the service container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Operation to perform on the service container */
                readonly 'application/json': {
                    /** @enum {string} */
                    readonly operation: 'start' | 'stop' | 'restart'
                }
            }
        }
        readonly responses: {
            /** @description Service container inspection after operation is performed */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Service container not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getContainerState: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Service container state */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Failed to get service container state */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly orchestrator: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Returns the name of the orchestrator being used to run Connectware */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['OrchestratorResponse']
                }
            }
            /** @description Access Forbidden */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Network error */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getCoreContainers: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description All core containers */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ContainersResponse']
                }
            }
        }
    }
    readonly inspectCoreContainer: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the core container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Core container inspect */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ContainerResponse']
                }
            }
            /** @description Failed to inspect core container */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getCoreContainerLogsStream: {
        readonly parameters: {
            readonly query?: {
                /** @description Timestamp for the start */
                readonly since?: string
                /** @description Use 'all' to retrieve all, or a number for a limited set */
                readonly tail?: string
                /** @description If the logs should yield timestamp */
                readonly timestamps?: 'true' | 'false'
                /** @description Timestamp for the end */
                readonly until?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the core container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Core container logs */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': string
                }
            }
            /** @description Failed to get core container logs */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly executeCoreContainerOperation: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the core container */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Operation to perform on the core container */
                readonly 'application/json': {
                    /** @enum {string} */
                    readonly operation: 'start' | 'stop' | 'restart'
                }
            }
        }
        readonly responses: {
            /** @description Core container inspection after operation is performed */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Core container not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getCoreContainerState: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Core Container state */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Failed to get core container state */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly coreOrchestrator: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Returns the name of the orchestrator being used to run Connectware */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['OrchestratorResponse']
                }
            }
            /** @description Network error */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly healthz: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getImages: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description All images */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly Record<string, never>[]
                }
            }
            /** @description Failed to get all images */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly inspectImages: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Image inspect */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Failed to inspect image */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getNetworks: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description All networks */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly Record<string, never>[]
                }
            }
            /** @description Failed to get all networks */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly inspectNetworks: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Network inspect */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': Record<string, never>
                }
            }
            /** @description Failed to inspect network */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getVolumes: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description All volumes */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['VolumesResponse']
                }
            }
        }
    }
    readonly inspectVolumes: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Name of the volume */
                readonly name: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Volume inspect */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['VolumeResponse']
                }
            }
            /** @description Failed to inspect volume */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
}

/** An auto-generated constant containing all paths */
export const pathsValue = [
    '/api/containers' as const,
    '/api/containers/+/inspect' as const,
    '/api/containers/+/logs' as const,
    '/api/containers/+/operation' as const,
    '/api/containers/+/state' as const,
    '/api/containers/orchestrator' as const,
    '/api/core-containers' as const,
    '/api/core-containers/+/inspect' as const,
    '/api/core-containers/+/logs' as const,
    '/api/core-containers/+/operation' as const,
    '/api/core-containers/+/state' as const,
    '/api/core-containers/orchestrator' as const,
    '/api/healthz' as const,
    '/api/images' as const,
    '/api/images/+/inspect' as const,
    '/api/networks' as const,
    '/api/networks/+/inspect' as const,
    '/api/volumes' as const,
    '/api/volumes/+/inspect' as const,
]
